import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ItemsForDealModalItem from '../../components/ItemsForDealModalItem/ItemsForDealModalItem';
import { itemsForDealModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { IDealItem } from 'src/types/combo';
import { emptyArray, getTranslate } from 'src/utils/helpers';
import { findSubstring } from 'src/utils/parser';

const ItemsForDealModalItems: FC = observer((): JSX.Element => {
  const { loading, searchValue, isSelectedCrumb, selectedItems, selectedCategories, pagination } = itemsForDealModalStore;

  const _selectedItems = useMemo(() => {
    return [...selectedItems].reduce((sum: IDealItem[], current) => {
      if (!findSubstring(getTranslate(current.name), searchValue)) return sum;
      if (selectedCategories.length && !selectedCategories.some((category) => Number(category.value) === Number(current.category_id))) return sum;

      return sum.concat(current);
    }, []);
  }, [selectedItems, selectedCategories, searchValue]);

  const itemsForRender = useMemo(() => {
    return isSelectedCrumb ? _selectedItems : pagination.data;
  }, [isSelectedCrumb, _selectedItems, pagination.data]);

  if (loading)
    return (
      <>
        {emptyArray().map((_, index) => (
          <ItemsForDealModalItem key={'key-' + String(index)} />
        ))}
      </>
    );

  if (!itemsForRender.length) {
    return (
      <div className="d-flex full-height full-width align-items-center">
        <p className="family-bold text-size-26 color-dark mx-auto my-auto">{localeStore.t('no_items_found')}</p>
      </div>
    );
  }

  return (
    <>
      {itemsForRender.map((item) => (
        <ItemsForDealModalItem key={item.id} item={item} />
      ))}
    </>
  );
});

export default ItemsForDealModalItems;
